module.exports = __webpack_public_path__ + "static/img/Magnussen.60f2875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Magnussen.jpg
// module id = C1aM
// module chunks = 1